import { useUser } from 'store/user';

const logoutUser = () => {
  localStorage.removeItem('token');

  const { setLogOut } = useUser.getState();
  setLogOut();
};

export default logoutUser;
